import API from '../AxiosInstance';

export default {
  getActiveAnnouncements: function(nodeId) {
    return API.get(`nodes/${nodeId}/announcements`);
  },
  dismissAnnouncement: function(nodeId, id) {
    return API.post(`nodes/${nodeId}/announcements/${id}/dismiss`);
  },
}
